<template>
  <div class="table-box">
    <el-table :border='true' row-class-name='table_row' @row-click='rowClick' header-row-class-name='table_head'
      height='550px' :data="tableData" style="width: 100%">
      <div slot="empty">
        <img src="@/assets/img/profile/kongbai.png" alt="">
        <div>暂无内容</div>
      </div>

      <el-table-column align='center' label="序号" type="index" width="50">
      </el-table-column>

      <el-table-column align='center' v-for="(item,index) of tableHeadList" :key="index" :prop="item.prop"
        :label="item.label">
      </el-table-column>

      <el-table-column align='center' prop="operation" label="操作">
        <template slot-scope="scope">
          <div @click.stop=''>

            <el-button style='cursor:pointer' type="text" @click.stop="handleDelete(scope.$index, scope,1)"
              size="small">
              编辑</el-button>

            <el-button style='cursor:pointer' type="text" @click.stop="handleDelete(scope.$index, scope,2)"
              size="small">
              删除</el-button>

          </div>

        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    //列表数据--------------------------------------------
    tableData: {
      type: Array,
      default() {
        return [];
      }
    },

    //头部--------------------------------------------
    tableHeadList: {
      type: Array,
      default() {
        return [
          {
            prop: "name",
            label: "教材名称"
          },
          {
            prop: "course",
            label: "科目"
          },
          {
            prop: "phase",
            label: "学段"
          },
          {
            prop: "grade",
            label: "年级"
          },
          {
            prop: "edition",
            label: "版本"
          },
          {
            prop: "volume",
            label: "册别"
          }
        ];
      }
    },

    //是否是图书类--------------------------------------------
    isBooks: {
      type: Boolean,
      default() {
        return false;
      }
    },

    //是否跳转详情--------------------------------------------
    isDetail: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },

  methods: {
    handleDelete(index, scope, type) {
      this.$emit("handleDelete", scope, type);
    },

    //某一行被点击到
    rowClick(row, column, event) {
      //App不跳详情--------------------------------------------
      if (!this.isDetail) return;
      if (this.isBooks) {
        this.$router.push({
          path: "/resource-detail",
          query: { id: row.id, type: "ebook" }
        });
      } else {
        this.$router.push({
          path: "/resource-detail",
          query: { id: row.id }
        });
      }
    }
  }
};
</script>



<style lang='less' scoped>
/deep/ .table_head {
  th {
    color: #333;
    background-color: #e9f5ed;
  }
}

/deep/ .table_row:nth-child(even) {
  background-color: #f5f5f5;
}

/deep/ .table_row {
  user-select: none;
}
</style> 